export class TypeValidationRule {
    name = 'type';
    validate(field, rule, value, object) {
        //Vars
        let tTypeName = rule.props.type;
        let tMessage = host.localizer?.tc('system.Validation.InValidValue', [field.displayName]) ?? '';
        let tValue = false;
        //Message
        if (rule.message) {
            tMessage = utils.format(rule.message, field.displayName);
        }
        //Check
        if (utils.isNullOrEmpty(value)) {
            return {
                isValid: true
            };
        }
        //Run
        switch (tTypeName.toLowerCase()) {
            case 'boolean':
                tValue = typeof value === 'boolean';
                break;
            case 'number':
                tValue = typeof value === 'number';
                break;
            case 'integer':
                tValue = typeof value === 'number' && parseInt(value.toString(), 10) === value;
                break;
            case 'float':
                tValue = typeof value === 'number' && parseInt(value.toString(), 10) !== value;
                break;
            case 'string':
                tValue = typeof value === 'string';
                break;
            case '':
                tValue = typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
                break;
            case 'url':
                tValue = (new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i')).test(value);
                break;
            case 'fon':
                tValue = /^[\+\(\s.\-\/\d\)]{5,22}$/.test(value);
                tMessage = host.localizer?.tc('system.Validation.PhoneNumber', [field.displayName]) ?? tMessage;
                break;
            case 'email':
                tValue = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
                tMessage = host.localizer?.tc('system.Validation.EmailAddress', [field.displayName]) ?? tMessage;
                break;
        }
        return {
            isValid: tValue,
            message: tValue ? undefined : tMessage
        };
    }
}
